// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"dialog_modalOverlay__5rElt","modalContent":"dialog_modalContent__F2xix","content":"dialog_content__p358L","icon":"dialog_icon__byWhc"};